import {
  getData, ifOkToJson, isDataFine, post, get,
  addRequestBody
} from './index'
import {Cacheable} from '../../utils/cache'
import {bus} from '../../utils/bus'
import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-guard`
// let baseUrl = `${httpUrl.localapi}/gy-guard`
let baseUrl83 = `${httpUrl.host}/gy-enterprise`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
// let baseUrl84 = '/api/kj-gy-apartment'

class Api {
  /* *********
   门禁组织树
   ********* */
  getOrganizationTreeList () {
    return post(`${baseUrl}/organization/getList`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getDeviceTreeList () {
    return post(`${baseUrl}/organization/getAllOrgAndDevChildren`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getOrganizationTreeListById (id) {
    return get(`${baseUrl}/organization/getByParentCode/${id}`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  addOrganization (organization) {
    return post(`${baseUrl}/organization/add`, organization)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  editOrganization (organization) {
    return post(`${baseUrl}/organization/update`, organization)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  removeOrganization (ids) {
    return post(`${baseUrl}/organization/deleteByCodes`, [ids])
      .then(ifOkToJson)
      .then(isDataFine)
  }

  /* *********
   门禁设备管理
   ********* */
  getResponsiblePersonList (searchKey) {
    return post(`${baseUrl}/person/getPersonListByName?searchKey=${searchKey}`)
      .then(ifOkToJson)
      .then(getData)
  }
  getEnterprisePerson (body) {
    return post(`${baseUrl85}/person/getList`, body)
      .then(ifOkToJson)
      .then(getData)
  }
  accessDeviceInfoDownloadUrl () {
    return `${baseUrl}/accessDevice/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`
  }

  accessDeviceInfoUploadUrl () {
    return `${baseUrl}/accessDevice/import`
  }

  organizationInfoDownloadUrl () {
    return `${baseUrl}/organization/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`
  }

  organizationInfoUploadUrl () {
    return `${baseUrl}/organization/import`
  }

  getAccessDevice (requestBody) {
    return post(`${baseUrl}/accessDevice/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  addAccessDevice (posDevice) {
    return post(`${baseUrl}/accessDevice/add`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  @Cacheable(5)
  getAccessDeviceByCode (code) {
    return get(`${baseUrl}/accessDevice/getByCode/${code}`)
      .then(ifOkToJson)
      .then(getData)
  }

  postAccessDevice (posDevice) {
    return post(`${baseUrl}/accessDevice/add`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  patchAccessDevice (posDevice) {
    return post(`${baseUrl}/accessDevice/update`, posDevice)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  deleteAccessDevice (codes) {
    return post(`${baseUrl}/accessDevice/deleteByCodes`, codes)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getAllDeviceManufacture (data) {
    return post(`${baseUrl85}/common/getAllDeviceManufacture`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  getAllDeviceType (data) {
    return post(`${baseUrl85}/common/getAllDeviceType`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  /* *********
   门禁授权
   ********* */
  getOrgAndDevChildrenById (id) {
    return post(`${baseUrl}/organization/getOrgAndDevChildrenById/${id}`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getAuthorityForEnterprise (requestBody) {
    return post(`${baseUrl}/authorityForEnterprise/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getAuthority (requestBody) {
    return post(`${baseUrl}/authority/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getFaceAuthorityStatus (requestBody) {
    return post(`${baseUrl}/faceAuthorityStatus/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseList () {
    return post(`${baseUrl85}/enterpriseInfo/getEnterpriseList`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  exportAuthorityInfo (requestBody) {
    return addRequestBody(
      `${baseUrl}/authority/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }

  exportFaceAuthorityStatus (requestBody) {
    return addRequestBody(
      `${baseUrl}/faceAuthorityStatus/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }

  deleteAuthority (data) {
    return post(`${baseUrl}/authority/unbindByCodes`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  deleteAuthorityForEnterprise (data) {
    return post(`${baseUrl}/authorityForEnterprise/unbindByCodes`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  /* *********
   开门记录
   ********* */
  getSwingCardRecordPage (requestBody) {
    return post(`${baseUrl}/swingCardRecord/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  exportSwingCardRecord (requestBody) {
    return addRequestBody(
      `${baseUrl}/swingCardRecord/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }

  /* *********
   报警记录配置
   ********* */
  getAlarmRecordPage (requestBody) {
    return post(`${baseUrl}/alarmRecord/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }
  exportAlarmRecord (requestBody) {
    return addRequestBody(
      `${baseUrl}/alarmRecord/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }
  /* *********
   设备状态日志
   ********* */
  getAccessDeviceStatusPage (requestBody) {
    return post(`${baseUrl}/accessDeviceStatus/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }
  exportAccessDeviceStatus (requestBody) {
    return addRequestBody(
      `${baseUrl}/accessDeviceStatus/export?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`, requestBody
    )
  }

  /* *********
   开门计划配置
   ********* */
  getOpenPlan (requestBody) {
    return post(`${baseUrl}/openPlan/getPage`, requestBody)
      .then(ifOkToJson)
      .then(getData)
  }

  getOpenPlanList () {
    return post(`${baseUrl}/openPlan/getList`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getOpenPlanByCode (code) {
    return get(`${baseUrl}/openPlan/getByCode/${code}`)
      .then(ifOkToJson)
      .then(getData)
  }

  deleteOpenPlan (codes) {
    return post(`${baseUrl}/openPlan/deleteByCodes`, [codes])
      .then(ifOkToJson)
      .then(isDataFine)
  }

  postOpenPlan (plan) {
    return post(`${baseUrl}/openPlan/add`, plan)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  patchOpenPlan (plan) {
    return post(`${baseUrl}/openPlan/update`, plan)
      .then(ifOkToJson)
      .then(isDataFine)
  }
  getDepAndPerChildrenById (id) {
    return post(`${baseUrl}/baseInfo/department/getDepAndPerChildrenById/${id}`, {})
      .then(ifOkToJson)
      .then(getData)
  }
  getBasicPersonPage (data) {
    return post(`${baseUrl}/authority/getPersonPage`, data)
      .then(ifOkToJson)
      .then(getData)
  }
  getNotPublicDeviceList (data) {
    return post(`${baseUrl}/accessDevice/getNotPublicDeviceList`, data || {})
      .then(ifOkToJson)
      .then(getData)
  }
  addAthority (data) {
    return post(`${baseUrl}/authority/bind`, data)
      .then(ifOkToJson)
      .then(isDataFine)
  }

  getResponsiblePerson (searchKey) {
    return post(`${baseUrl85}/person/getResponsiblePersonList`, {
      searchKey
    })
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseInfoList () {
    return post(`${baseUrl85}/enterpriseInfo/getEnterpriseList`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getAccessDeviceChildrenByCode (code) {
    return get(`${baseUrl}/organization/getOrgAndDevChildren/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseByCode (code) {
    return get(`${baseUrl85}/enterpriseInfo/getEnterpriseByCode/${code}`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getGatewayDeviceList (data) {
    return post(`${baseUrl}/accessDevice/getGatewayDeviceList`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  getEnterpriseListByRoom (data) {
    return post(`${baseUrl}/organization/getEnterpriseList`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 门禁概览
  getAccessDeviceOverview () {
    return get(`${baseUrl}/guardOverview/getAccessDeviceOverview`, {})
      .then(ifOkToJson)
      .then(getData)
  }

  getSwingCardRecordStatictics (data) {
    return post(`${baseUrl}/guardOverview/getSwingCardRecordStatictics`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 获取人数
  getDevicePersonCount (data) {
    return post(`${baseUrl}/accessDevice/findAllFaceInfoQuantity`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 同步人脸
  syncPersonPicToDevice (data) {
    return post(`${baseUrl}/accessDevice/syncPersonPicToDevice`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 清空人脸
  clearAllFace (data) {
    return post(`${baseUrl}/accessDevice/clearAllFace`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 重新下发
  reAuthority (data) {
    return post(`${baseUrl}/faceAuthorityStatus/reAuthority`, data)
      .then(ifOkToJson)
      .then(getData)
  }

  // 修改照片
  updateAuthorityImage (data) {
    return post(`${baseUrl}/faceAuthorityStatus/updateAuthorityImage`, data)
      .then(ifOkToJson)
      .then(getData)
  }
}
let newApi = {
  // 同步门禁设备
  syncDevice: `${baseUrl}/accessDevice/syncDevice`
}

const api = new Api()
export default api
export { api }
export {newApi}



// WEBPACK FOOTER //
// ./src/view/api/access-ctrl.js